module.exports = __webpack_public_path__ + "img/Rectangle 17.8fc2a936.png";